enum PlanCode {
  Annual = 'annual',
  AnnualOnce = 'annualOnce',
  SevenDayTrial = 'sevenDayTrial',
  Monthly = 'monthly'
}

export default PlanCode;
